import { Injectable } from '@angular/core';

/**
 * La clave para el LocalStorage
 */
const REMEMBER_LOCALSTORAGE_KEY = 'rememberMe';

interface Credenciales {
  username: string;
  password: string;
}

@Injectable()
export class RememberMeService {

  isRememberMeActive() {
    return localStorage.getItem(REMEMBER_LOCALSTORAGE_KEY) != null;
  }

  get(): Credenciales {
    if (this.isRememberMeActive()) {
      return JSON.parse(localStorage.getItem(REMEMBER_LOCALSTORAGE_KEY));
    }
    return null;
  }

  set(credentials: Credenciales) {
    localStorage.setItem(REMEMBER_LOCALSTORAGE_KEY, JSON.stringify(credentials));
  }

  remove() {
    localStorage.removeItem(REMEMBER_LOCALSTORAGE_KEY);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/rememberme.service.ts